import { RefObject, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { isClientSide } from '@r1-frontend/shared/helpers/ssr';
import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import { agreementCreationStatuses } from '~/src/features/full-buy/consts';
import { MainLayout } from '~/src/features/full-buy/containers/MainLayout/MainLayout';

import * as ST from './styles';

interface IProps {
    parent?: RefObject<HTMLElement>,
}

const Loader = ({ parent }: IProps) => {
    const [root, setRoot] = useState<HTMLElement | null>(null);
    const isMobile = useMatchMedia(`(max-width: ${wideBreakpoints.mobile})`);

    useEffect(() => {
        if (isClientSide()) {
            const portal = parent ? parent.current : document.getElementById('loader-portal');
            if (portal) {
                if (isMobile) {
                    portal.style.minHeight = '70vh';
                } else {
                    portal.style.minHeight = 'auto';
                }
                setRoot(portal);
            }
        }
    }, [isMobile, parent]);

    return root
        ? createPortal(
            (
                <MainLayout>
                    <ST.SInteractiveLoader
                        textItems={agreementCreationStatuses}
                        delay={10}
                        loopSegmentAtIndex={5}
                    />
                </MainLayout>
            ),
            root,
        )
        : null;
};

export default Loader;
